import type { FunctionComponent } from 'react';

import { token } from '@trello/theme';

export const TemplatesTileSkeleton: FunctionComponent = (props) => (
  <svg
    className="templatesTileSkeleton"
    width={260}
    height={132}
    viewBox="0 0 260 132"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient
        id="templates-tile-skeleton-animation"
        x2={352}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="-200%"
          stopColor={token('color.skeleton.subtle', '#091E4208')}
        >
          <animate
            attributeName="offset"
            values="-2;1"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="-160%" stopColor={token('color.skeleton', '#091E420F')}>
          <animate
            attributeName="offset"
            values="-1.6;1.4"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="-140%" stopColor={token('color.skeleton', '#091E420F')}>
          <animate
            attributeName="offset"
            values="-1.4;1.6"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="-100%"
          stopColor={token('color.skeleton.subtle', '#091E4208')}
        >
          <animate
            attributeName="offset"
            values="-1;2"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        fill="url(#templates-tile-skeleton-animation)"
        x={0}
        y={0}
        width={'100%'}
        height={'100%'}
        rx={4}
      />
    </g>
  </svg>
);
